var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#download_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.31 7.685a.469.469 0 0 1 .663 0l2.481 2.481 2.48-2.481a.469.469 0 1 1 .664.663l-2.812 2.813a.47.47 0 0 1-.664 0L5.31 8.348a.469.469 0 0 1 0-.663Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.454.985a.469.469 0 0 1 .469.47v8.437a.469.469 0 1 1-.938 0V1.454a.469.469 0 0 1 .47-.469Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.36 12.704a1.406 1.406 0 0 0 1.407 1.406h9.375a1.407 1.407 0 0 0 1.406-1.406v-7.5a1.406 1.406 0 0 0-1.406-1.406h-1.407a.469.469 0 1 0 0 .937h1.407a.469.469 0 0 1 .468.47v7.5a.469.469 0 0 1-.468.468H3.767a.469.469 0 0 1-.47-.469v-7.5a.469.469 0 0 1 .47-.469h1.406a.469.469 0 1 0 0-.937H3.767A1.406 1.406 0 0 0 2.36 5.204v7.5Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "download_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.954 .048)",
  d: "M0 0h15v15H0z"
})))));
export default SvgDownload;